// PatternContext.tsx
import React, { createContext, useContext, useState, ReactNode } from 'react';
import { PatternInfoProps } from '../page/aiAnalyze/myAlgorithm/result/report/data';
import { Invest, Profit } from '../page/aiAnalyze/myAlgorithm/algorithmType';
import {
  InitialInvestOptions,
  InitialProfitOptions,
} from '../page/aiAnalyze/myAlgorithm/data';

interface PatternContextType {
  available: boolean;
  setAvailable: React.Dispatch<React.SetStateAction<boolean>>;
  pIdx: number;
  setPIdx: React.Dispatch<React.SetStateAction<number>>;
  patternInfo: PatternInfoProps;
  setPatternInfo: React.Dispatch<React.SetStateAction<PatternInfoProps>>;
  investOptions: Invest;
  setInvestOptions: React.Dispatch<React.SetStateAction<Invest>>;
  profitOptions: Profit;
  setProfitOptions: React.Dispatch<React.SetStateAction<Profit>>;
}
// Create the context with a default value
const PatternContext = createContext<PatternContextType | undefined>(undefined);

// Provider component to wrap around the app and provide context
export const PatternProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [available, setAvailable] = useState(false);
  const [pIdx, setPIdx] = useState<number>(0);
  // 투자 알고리즘
  const [investOptions, setInvestOptions] =
    useState<Invest>(InitialInvestOptions);
  // 수익 알고리즘
  const [profitOptions, setProfitOptions] =
    useState<Profit>(InitialProfitOptions);

  const [patternInfo, setPatternInfo] = useState<PatternInfoProps>({
    algorithm_idx: 0,
    pnu: '',
    category: '',
    category_detail: '',
    investment_period: '',
    investment_purpose: '',
    aging_start_year: '',
    aging_end_year: '',
    zoning: '',
    revenue_type: '',
    cost_included: '',
    investment_type: '',
    min_investment_value: '',
    max_investment_value: '',
    investment_rate: '',
    profit_rate: '',
    min_bid_cnt: '',
    max_bid_cnt: '',
    risk: '',
    prc_reliability: '',
    auction_date_years: '',
    create_time: '',
    is_saved: '',
    name: '',
    grade: 0,
    profit_status: '',
    value_status: '',
  });

  return (
    <PatternContext.Provider
      value={{
        available,
        setAvailable,
        pIdx,
        setPIdx,
        patternInfo,
        setPatternInfo,
        investOptions,
        setInvestOptions,
        profitOptions,
        setProfitOptions,
      }}
    >
      {children}
    </PatternContext.Provider>
  );
};

// Custom hook to use the PatternContext
export const usePatternContext = (): PatternContextType => {
  const context = useContext(PatternContext);
  if (!context) {
    throw new Error('usePatternContext must be used within a PatternProvider');
  }
  return context;
};
